import React from 'react';

import GlobalSearch from '..';

const GlobalSearchWrapper = (props) => (
    <GlobalSearch {...props} />
);

export default GlobalSearchWrapper;
